import { GlobalConstants } from "../../../common/constants/global.constant";

export const processorNamesConstant = [
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_X7_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ Ultra X7 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_X9_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ Ultra X9 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_5_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ Ultra 5 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_7_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ Ultra 7 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_9_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ Ultra 9 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_3_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ 3 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_5_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ 5 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_7_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ 7 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_9_PROCESSOR_SERIES_3,
    nameInEng: 'Intel® Core™ 9 Series 3 processor',
    group: '17'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_5_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ Ultra 5 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_7_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ Ultra 7 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_9_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ Ultra 9 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_3_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ 3 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_5_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ 5 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_7_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ 7 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_9_PROCESSOR_SERIES_2,
    nameInEng: 'Intel® Core™ 9 Series 2 processor',
    group: '16'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_5_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ Ultra 5 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_7_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ Ultra 7 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.INTEL_CORE_ULTRA_9_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ Ultra 9 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.INTEL_CORE_3_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ 3 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.INTEL_CORE_5_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ 5 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.INTEL_CORE_7_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ 7 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.INTEL_CORE_9_PROCESSOR_SERIES_1,
    nameInEng: 'Intel® Core™ 9 Series 1 processor',
    group: '15'
  },
  {
    name: GlobalConstants.FOURTEEN_GEN_INTEL_CORE_I3,
    nameInEng: 'Intel® Core™ i3 processor (14th gen)',
    group: '14'
  },
  {
    name: GlobalConstants.FOURTEEN_GEN_INTEL_CORE_I5,
    nameInEng: 'Intel® Core™ i5 processor (14th gen)',
    group: '14'
  },
  {
    name: GlobalConstants.FOURTEEN_GEN_INTEL_CORE_I7,
    nameInEng: 'Intel® Core™ i7 processor (14th gen)',
    group: '14'
  },
  {
    name: GlobalConstants.FOURTEEN_GEN_INTEL_CORE_I9,
    nameInEng: 'Intel® Core™ i9 processor (14th gen)',
    group: '14'
  },
  {
    name: GlobalConstants.THIRTEENTH_GEN_INTEL_CORE_I3,
    nameInEng: '13th Gen Intel® Core™ i3 processor',
    group: '13'
  },
  {
    name: GlobalConstants.THIRTEENTH_GEN_INTEL_CORE_I5,
    nameInEng: '13th Gen Intel® Core™ i5 processor',
    group: '13'
  },
  {
    name: GlobalConstants.THIRTEENTH_GEN_INTEL_CORE_I7,
    nameInEng: '13th Gen Intel® Core™ i7 processor',
    group: '13'
  },
  {
    name: GlobalConstants.THIRTEENTH_GEN_INTEL_CORE_I9,
    nameInEng: '13th Gen Intel® Core™ i9 processor',
    group: '13'
  },
  {
    name: GlobalConstants.TWELFTH_GEN_INTEL_CORE_I3,
    nameInEng: '12th Gen Intel® Core™ i3 processor',
    group: '12'
  },
  {
    name: GlobalConstants.TWELFTH_GEN_INTEL_CORE_I5,
    nameInEng: '12th Gen Intel® Core™ i5 processor',
    group: '12'
  },
  {
    name: GlobalConstants.TWELFTH_GEN_INTEL_CORE_I7,
    nameInEng: '12th Gen Intel® Core™ i7 processor',
    group: '12'
  },
  {
    name: GlobalConstants.TWELFTH_GEN_INTEL_CORE_I9,
    nameInEng: '12th Gen Intel® Core™ i9 processor',
    group: '12'
  },
  {
    name: GlobalConstants.ELEVENTH_GEN_INTEL_CORE_I3,
    nameInEng: '11th Gen Intel® Core™ i3 processor',
    group: '11'
  },
  {
    name: GlobalConstants.ELEVENTH_GEN_INTEL_CORE_I5,
    nameInEng: '11th Gen Intel® Core™ i5 processor',
    group: '11'
  },
  {
    name: GlobalConstants.ELEVENTH_GEN_INTEL_CORE_I7,
    nameInEng: '11th Gen Intel® Core™ i7 processor',
    group: '11'
  },
  {
    name: GlobalConstants.ELEVENTH_GEN_INTEL_CORE_I9,
    nameInEng: '11th Gen Intel® Core™ i9 processor',
    group: '11'
  },
  {
    name: GlobalConstants.TENTH_GEN_INTEL_CORE_I3,
    nameInEng: '10th Gen Intel® Core™ i3 processor',
    group: '10'
  },
  {
    name: GlobalConstants.TENTH_GEN_INTEL_CORE_I5,
    nameInEng: '10th Gen Intel® Core™ i5 processor',
    group: '10'
  },
  {
    name: GlobalConstants.TENTH_GEN_INTEL_CORE_I7,
    nameInEng: '10th Gen Intel® Core™ i7 processor',
    group: '10'
  },
  {
    name: GlobalConstants.TENTH_GEN_INTEL_CORE_I9,
    nameInEng: '10th Gen Intel® Core™ i9 processor',
    group: '10'
  },
  {
    name: GlobalConstants.NINETH_GEN_INTEL_CORE_I3,
    nameInEng: '9th Gen Intel® Core™ i3 processor',
    group: '9'
  },
  {
    name: GlobalConstants.NINETH_GEN_INTEL_CORE_I5,
    nameInEng: '9th Gen Intel® Core™ i5 processor',
    group: '9'
  },
  {
    name: GlobalConstants.NINETH_GEN_INTEL_CORE_I7,
    nameInEng: '9th Gen Intel® Core™ i7 processor',
    group: '9'
  },
  {
    name: GlobalConstants.NINETH_GEN_INTEL_CORE_I9,
    nameInEng: '9th Gen Intel® Core™ i9 processor',
    group: '9'
  },
  {
    name: GlobalConstants.EIGHTH_GEN_INTEL_CORE_I3,
    nameInEng: '8th Gen Intel® Core™ i3 processor',
    group: '8'
  },
  {
    name: GlobalConstants.EIGHTH_GEN_INTEL_CORE_I5,
    nameInEng: '8th Gen Intel® Core™ i5 processor',
    group: '8'
  },
  {
    name: GlobalConstants.EIGHTH_GEN_INTEL_CORE_I7,
    nameInEng: '8th Gen Intel® Core™ i7 processor',
    group: '8'
  },
  {
    name: GlobalConstants.EIGHTH_GEN_INTEL_CORE_I9,
    nameInEng: '8th Gen Intel® Core™ i9 processor',
    group: '8'
  },
  {
    name: GlobalConstants.INTEL_PROCESSOR_N_SERIES,
    nameInEng: 'Intel® Processor N-series',
    group: 'Other'
  },
  {
    name: GlobalConstants.INTEL_PROCESSOR_U_SERIES,
    nameInEng: 'Intel® Processor U-series',
    group: 'Other'
  },
  {
    name: GlobalConstants.INTEL_PENTIUM_GOLD,
    nameInEng: 'Intel® Pentium® Gold',
    group: 'Other'
  },
  {
    name: GlobalConstants.INTEL_PENTIUM_SILVER,
    nameInEng: 'Intel® Pentium® Silver',
    group: 'Other'
  },
  {
    name: GlobalConstants.INTEL_PENTIUM_PROCESSOR_N_SERIES,
    nameInEng: 'Intel® Pentium® Processor N Series',
    group: 'Other'
  }, {
    name: GlobalConstants.INTEL_CELERON_PROCESSOR_G_SERIES,
    nameInEng: 'Intel® Celeron® Processor G Series',
    group: 'Other'
  },
  {
    name: GlobalConstants.INTEL_CELERON_PROCESSOR_J_SERIES,
    nameInEng: 'Intel® Celeron® Processor J Series',
    group: 'Other'
  }, {
    name: GlobalConstants.INTEL_CELERON_PROCESSOR_N_SERIES,
    nameInEng: 'Intel® Celeron® Processor N Series',
    group: 'Other'
  }
]